import { Button, ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ViewAndApplyButton(props: Pick<ButtonProps, 'onClick'>) {
    const { t } = useTranslation('candidateOffers');

    return (
        <Button variant="contained" 
            { ...props }
        >
            { t('viewAndApply') }
        </Button>
    );
}
